import { styled } from 'styled-components';

export const StyledLoader = styled.svg`
  margin: auto;
  display: block;
`;
